// extracted by mini-css-extract-plugin
module.exports = {"container":"VehicleCard_container__goPtV","image":"VehicleCard_image__ON6Qn","dash":"VehicleCard_dash__nVRTt","star":"VehicleCard_star__0vXx8"};